
import { Component, OnDestroy, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { CapabilityType } from 'src/app/models/service/capability';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
// import { AddBuildVersionFormComponent } from '../add-build-version-form/add-build-version-form.component';
import { SolutionVersionDetailsComponent } from '../solution-version-details/solution-version-details.component';
import { Permission } from '../../../models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import cloneDeep from 'lodash/cloneDeep';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { RouterSegments } from 'src/app/models/router-segments';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { SolutionStatus } from 'src/app/models/service/solution-status';
import { Constants } from 'src/app/models/constants';
import {animate, state, style, transition, trigger} from '@angular/animations';

const REQUIRED_PERMISSIONS = [
  Permission.ADD_SOLUTION_VERSION,
  Permission.EDIT_SOLUTION_VERSION,
  Permission.DELETE_SOLUTION_VERSION
];

@Component({
    selector: 'app-external-package',
    templateUrl: './external-package.component.html',
    styleUrls: ['./external-package.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ExternalPackageComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  Constants = Constants;
  CapabilityType = CapabilityType;
  RouterSegments = RouterSegments;
  solutionId: string;
  tenant: string;
  solutionVersions: any;
  dataSource: any;
  displayedColumns = ['version', 'releaseVersion', 'description', 'created', 'status'];
  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  showSpinner: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  isReader: boolean;
  solutionName: string;
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  isFailed = false;
  breadcrumbItem: any;
  urlSolution: any;
  solutionItem: any;
  tenantId: string;
  SolutionStatus = SolutionStatus;
  externalPackages: any;
  stepsArray = [1, 2, 3];
  currentStep = 1;
  selectedVersion: any;
  selectedExternalPackage: any;
  searchValue: any;
  filteredExternalPackages: any;
  expandedElement: any;
  dataSourceInnerPackages: any;
  allExternalPackages: any;
  innerTableColumns: string[] = ['name', 'path', 'version'];
  dataSourceInner: any;
  searchText: any;
  componentsData: any;
  componentsDatas: any;
  noData: boolean;
  choosePackage: boolean;
  dateCreated: any;
  isLoading: boolean;
  noDataFound: boolean;


  constructor(private activatedRoute: ActivatedRoute, private toastrService: CustomToastrService,
    private solutionsService: SolutionsService, private authService: AuthService, private sidenavService: SidenavService,
    public dateTimeFormatService: DateTimeFormatService, private permissionsService: PermissionsService,
    private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private router: Router) {
      
     }

  ngOnInit(): void {
    this.isLoading = true;
    this.choosePackage = this.selectedExternalPackage ? false : true;
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SOLUTIONS';
    this.tenant = this.authService.principal.provider;
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;
    this.solutionName = localStorage.getItem('tenantViewSolutionName');
    this.breadcrumbItem = localStorage.getItem('tenantViewBreadcrumbItem');
    this.urlSolution = localStorage.getItem('tenantViewUrlSolution');
    this.solutionItem = localStorage.getItem('tenantViewSolutionItem');
    this.noData = false;
    this.breadcrumbItems.push(
      {label: translate('TENANT_LAYOUT.MENU.SOLUTIONS'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.SOLUTION]},
      {label: this.solutionName});
      this.getExternalPackages();
  }

  getExternalPackages(): void {
    this.solutionsService.getReferencePackages(this.solutionId, this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
       if (data.total > 10) {
        const size = data.total
        this.solutionsService.getReferencePackages(this.solutionId, this.tenantId, size)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(results => {
            this.isLoading = false;
            this.noDataFound = false;
            this.externalPackages = results.data;
            this.filteredExternalPackages = this.externalPackages;
          });
      } else {
      this.isLoading = false;
      if(data.data.length === 0) {
        this.noDataFound = true;
        this.choosePackage = false;
      } else {
        this.noDataFound = false;
      }
      this.externalPackages = data.data;
      this.filteredExternalPackages = this.externalPackages;
    }
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.filteredExternalPackages = this.externalPackages;
    });
  }

  externalPackageChanged(value): void {
    this.selectedExternalPackage = value;
    this.componentsData = this.selectedExternalPackage.references;
    this.dateCreated = value.dateCreated;
    this.choosePackage = this.selectedExternalPackage ? false : true;

    this.expandedElement = null;
    this.selectedExternalPackage.references.forEach(data => data.arrowClick = false);
    this.dataSource = new MatTableDataSource(this.selectedExternalPackage?.references);
  }

  searchChanged(value): void {
    this.filteredExternalPackages = this.externalPackages.filter(item => item?.name?.toLowerCase().startsWith(value.toLowerCase()));
  }

  searchChangedOnKeyUp(event): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.componentsData = this.selectedExternalPackage.references;
    if (this.searchText) {
      this.componentsData = this.componentsData.filter(item => item.component.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.componentsData = this.componentsData;
    }
    if(this.componentsData.length === 0) {
      this.noData = true;
    } else {
      this.noData = false;
    }
    this.expandedElement = null;
    this.componentsData?.forEach(item =>  {
        item.arrowClick = false;
    });
  }


  onClick(event) {
    if (this.filteredExternalPackages?.length === 0) {
      this.filteredExternalPackages = this.externalPackages;
      this.searchValue = undefined;
    }
  }

  onArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.selectedExternalPackage.references.find(item => item.component === data.component).arrowClick = !this.selectedExternalPackage?.references?.find(item => item.component === data.component)?.arrowClick;
    this.selectedExternalPackage?.references?.forEach(item =>  {
      if(item.component !== data.component) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInner = this.selectedExternalPackage?.references?.find(item => item.component === data.component).images;
    this.dataSourceInnerPackages = this.selectedExternalPackage?.references?.find(item => item.component === data.component).packages;
  }

}
